import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marca POR PETICIÓN: "esta petición NO lleva `totp_code`; un 401 que la
 * clasificación de sesión lee como `refresh` ES una sesión vencida, aunque su ruta
 * case con alguna lista `EXCLUDED_*` de `auth.interceptor.ts`".
 *
 * Existe porque la exclusión por RUTA mezcla dos cosas: "no abras el modal genérico"
 * y "no entres a la rama de sesión". La segunda solo protege a las escrituras con
 * step-up (su 401 de código malo dice "…inválido o expirado"); a una lectura le
 * cuesta una sesión vencida que nadie avisa. Contrato, que es lo que hay que
 * respetar al reutilizarla:
 *
 * 1. **Default `false`.** Una petición que no la conoce decide su 401 exactamente
 *    como siempre (condicionado a las listas `EXCLUDED_*`).
 * 2. **Solo afecta a la rama de token expirado.** NO toca el modal genérico (lo
 *    siguen decidiendo la exclusión, `SILENT_BACKGROUND_READ` y el bloqueo del
 *    TOTP) ni las ramas de sesión invalidada / cuenta deshabilitada, que ya no
 *    dependen de la exclusión.
 * 3. **PROHIBIDA en escrituras con step-up TOTP.** Su única razón de existir es que
 *    el falso "expirado" del segundo factor no puede ocurrir en la petición marcada;
 *    puesta en una de ellas, un dígito mal tecleado abriría el diálogo de sesión.
 * 4. **La pone el ORIGEN, nunca la ruta** (como `SILENT_BACKGROUND_READ`): quien
 *    construye la petición es el único que sabe que no lleva `totp_code`. La misma
 *    URL pedida desde otro sitio conserva su comportamiento.
 *
 * `HttpContext` es client-side: no viaja al backend.
 */
export const SESSION_EXPIRY_NOT_EXCLUDED = new HttpContextToken<boolean>(() => false);

/** Devuelve `base` (o un contexto nuevo) con la marca puesta; conserva las marcas que ya traiga. */
export function withSessionExpiryNotExcluded(base?: HttpContext): HttpContext {
  return (base ?? new HttpContext()).set(SESSION_EXPIRY_NOT_EXCLUDED, true);
}
